var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "w-full h-full flex flex-col bg-[#FFFFFF] p-2"
  }, [_c('div', {
    staticClass: "left flex items-center gap-2 flex-wrap p-2 justify-between",
    on: {
      "click": _vm.goBack
    }
  }, [_c('nav', {
    staticClass: "text-[#333333] text-[14px] flex items-center gap-2"
  }, [_c('Icon', {
    staticClass: "border-solid p-1 border-[2px] rounded-full",
    attrs: {
      "type": "md-arrow-round-back"
    }
  }), _c('span', {
    staticClass: "text-[16px] font-bold"
  }, [_vm._v(_vm._s(_vm.appdetail.name))])], 1)]), _c('Tabs', {
    staticClass: "app_detail_tabs",
    attrs: {
      "name": "tabs-1"
    },
    model: {
      value: _vm.tabValue,
      callback: function ($$v) {
        _vm.tabValue = $$v;
      },
      expression: "tabValue"
    }
  }, [_c('TabPane', {
    staticClass: "app_detail_tabs_content",
    attrs: {
      "label": $t("blh1h04", "基础信息"),
      "name": "base-info",
      "tab": "tabs-1"
    }
  }, [_c('base-info', {
    attrs: {
      "appdetail": _vm.appdetail
    },
    on: {
      "on-update": _vm.getAppDetail
    }
  })], 1), _c('TabPane', {
    attrs: {
      "label": $t("i8zabu4", "访问授权"),
      "name": "authorization",
      "tab": "tabs-1"
    }
  }, [_c('authorization', {
    attrs: {
      "appdetail": _vm.appdetail
    },
    on: {
      "on-update": _vm.getAppDetail
    }
  })], 1), _vm.isAzure ? [_c('TabPane', {
    attrs: {
      "label": $t("c72yjo4", "密钥管理")
    }
  }, [_c('AppDetailTabAzure', {
    attrs: {
      "detail": _vm.appdetail
    }
  })], 1)] : _vm._e(), _vm.isDingDing || _vm._third ? [_c('TabPane', {
    attrs: {
      "label": $t("cf0f484", "应用凭证"),
      "name": "name2"
    }
  }, [_vm.isDingDing ? _c('AppDetailTab2', {
    attrs: {
      "item": _vm.item,
      "detail": _vm.appdetail
    }
  }) : _c('AppDetailTab2Third', {
    attrs: {
      "detail": _vm.appdetail
    }
  })], 1), !_vm._isEnterpriseWechatSync ? _c('TabPane', {
    attrs: {
      "label": $t("dnhnle4", "权限管理"),
      "name": "name3"
    }
  }, [_vm.isDingDing ? _c('AppDetailTab3') : _c('AppDetailTab3Third')], 1) : _vm._e(), _c('TabPane', {
    attrs: {
      "label": $t("cf8e224", "应用自检"),
      "name": "name4"
    }
  }, [_c('AppDetailTab4', {
    attrs: {
      "detail": _vm.appdetail
    }
  })], 1)] : _vm._e(), _vm._isEnterpriseWechatSync ? [_c('TabPane', {
    attrs: {
      "label": $t("d7cdtl5", "通讯录同步"),
      "name": "contact-sync"
    }
  }, [_c('AppDetailContactSync', {
    attrs: {
      "app-id": _vm.appdetail.appId
    }
  })], 1)] : _vm._e(), _vm._isThirdDingDing ? [_c('TabPane', {
    attrs: {
      "label": $t("d7kdp34", "数据同步"),
      "name": "name9"
    }
  }, [_vm.tabValue === 'name9' ? _c('AppDetailPositionSync') : _vm._e()], 1)] : _vm._e(), (_vm._third || _vm._isOperaCloud) && !_vm._isEnterpriseWechatSync ? [_c('TabPane', {
    attrs: {
      "label": $t("iwitmt4", "部门管理"),
      "name": "name5"
    }
  }, [_vm.tabValue === 'name5' ? _c('AppDetailTab5', {
    attrs: {
      "detail": _vm.appdetail
    }
  }) : _vm._e()], 1), _c('TabPane', {
    attrs: {
      "label": $t("hxhx7p4", "角色管理"),
      "name": "name6"
    }
  }, [_vm.tabValue === 'name6' ? _c('AppDetailTab6', {
    attrs: {
      "detail": _vm.appdetail
    }
  }) : _vm._e()], 1)] : _vm._e(), _vm._isOperaCloud ? [_c('TabPane', {
    attrs: {
      "label": $t("cf0irm4", "应用参数"),
      "name": "name7"
    }
  }, [_vm.tabValue === 'name7' ? _c('AppDetailTab7', {
    attrs: {
      "detail": _vm.appdetail
    }
  }) : _vm._e()], 1), _c('TabPane', {
    attrs: {
      "label": $t("d7kdp34", "数据同步"),
      "name": "name8"
    }
  }, [_vm.tabValue === 'name8' ? _c('AppDetailTab8', {
    attrs: {
      "detail": _vm.appdetail
    }
  }) : _vm._e()], 1)] : _vm._e()], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };